export const categoryMap = {
  "Schools (Elementary, Middle, High Schools)": "Schools",
  "Libraries or Learning Centers": "Libraries",
  "Hospitals or Medical Centers": "Hospitals",
  "Bus Stops or Transit Stations": "Transit Stations",
  "Shopping Malls or Retail Centers": "Shopping Malls",
  "Live Theaters or Performing Arts Centers": "Live Theaters",
  "Farmers' Markets or Organic Stores": "Farmers' Markets",
  "Clinics or Urgent Care Facilities": "Clinics",
  "Grocery Stores or Supermarkets": "Grocery Stores",
};
